module.exports = "pegasus/assets/blocks/column-17-basic.png";